export const EmpKey = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMP_CODE: 'empCode',
  GENDER: 'gender',
  EMAIL: 'email',
  MOBILE: 'mobile',
  DATE_JOINING: 'dateOfJoining',
  DATE_RESIGNING: 'dateOfResignation',
  WORKING_DAYS: 'workingDaysInWeek',
  MODE: 'mode',
  DISTANCE_TRAVELLED: 'distanceTravelled',
  HOME_ADD: 'homeAddr',
  OFFICE_ADD: 'officeAddr',
  DESIGNATION: 'designation',
  FACILITY_TYPE: 'type',
  COUNTRY: 'country',
  STATUS: 'status',
  COMMENT: 'comment'
};

export const EmpLabel = {
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  EMP_CODE: 'Employee Code',
  GENDER: 'Gender',
  EMAIL: 'Email ID',
  MOBILE: 'Mobile Number',
  DATE_JOINING: 'Date of Joining',
  DATE_RESIGNING: 'Date of Resignation',
  WORKING_DAYS: 'Working Days in a week',
  MODE: 'Mode of Transport',
  DISTANCE_TRAVELLED: 'Distance Travelled',
  HOME_ADD: 'Home Address',
  OFFICE_ADD: 'Office Address',
  DESIGNATION: 'Designation',
  FACILITY_TYPE: 'Facility Type',
  COUNTRY: 'Country',
  STATUS_COMMENTS: 'Status & Comments',
  STATUS: 'Status',
  COMMENT: 'Comment'
};
